import UrunCategories from "./Modules/Urunler/UrunCategories";
import UrunList from "./Modules/Urunler/UrunList";
import UrunEkle from "./Modules/Urunler/UrunEkle";
import UrunListeleri from "./Modules/Urunler/UrunListeleri";
import UrunOzellikleri from "./Modules/Urunler/UrunOzellikleri";

export default {
  namespaced: true,
  modules: {
    UrunCategories: UrunCategories,
    UrunEkle: UrunEkle,
    UrunList: UrunList,
    UrunListeleri: UrunListeleri,
    UrunOzellikleri: UrunOzellikleri,
  },
};
